export { UpsellStrategy as Upsell } from './upsell-strategy';
export { default as UpsellItem } from './upsell-item';
